import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import { IconButton, InputBase } from '@mui/material';
import { ChangeEvent, useRef, useState } from 'react';
import { useClickAway } from 'react-use';

import { useIsPortraitMode, useIsSmallDevice } from '#shared';

import { searchbarClasses, SearchbarStyled } from './Searchbar.styled';
import { SearchResults } from './SearchResults';

import type { SearchResult } from '../../../slices';

interface SearchbarProps {
  className?: string;
  value?: string;
  placeholder?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFilterClick?: () => void;
  results?: SearchResult[];
  onFocusChange?: (focused: boolean) => void;
}

export const Searchbar = ({
  className,
  value,
  placeholder = 'Search',
  onChange,
  results = [],
  onFocusChange,
}: SearchbarProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const isSmallDevice = useIsSmallDevice();
  const isPortraitMode = useIsPortraitMode();
  const [isCollapsed, setIsCollapsed] = useState(
    isSmallDevice || isPortraitMode,
  );
  const wrapperRef = useRef(null);

  const handleSelect = (val: string) => {
    if (val.length) {
      onChange?.({ target: { value: val } } as ChangeEvent<HTMLInputElement>);
    }

    setIsFocused(false);
    onFocusChange?.(false);
  };

  const handleClear = () => {
    onChange?.({ target: { value: '' } } as ChangeEvent<HTMLInputElement>);
    onFocusChange?.(false);
  };

  const valueLength = value ? value.length : 0;
  const hasValue = valueLength >= 1;

  useClickAway(wrapperRef, () => {
    setIsFocused(false);
    onFocusChange?.(false);
    if (isSmallDevice || isPortraitMode) {
      setIsCollapsed(true);
    }
  }, ['pointerdown']);

  return (
    <SearchbarStyled
      ref={wrapperRef}
      isSmallDevice={isSmallDevice}
      isCollapsed={isCollapsed}
      isPortrait={isPortraitMode}
      className={`${searchbarClasses.root} ${className || ''}`}
      onFocus={() => {
        setIsFocused(true);
        onFocusChange?.(true);
      }}
    >
      <IconButton onClick={() => setIsCollapsed(false)} size="small">
        <SearchIcon className={searchbarClasses.icon} />
      </IconButton>

      {!isCollapsed && (
        <InputBase
          className={searchbarClasses.input}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      )}

      {hasValue && !isCollapsed && (
        <IconButton onClick={handleClear} size="small">
          <CloseIcon className={searchbarClasses.icon} />
        </IconButton>
      )}

      {/*{!isCollapsed ? (*/}
      {/*  <>*/}
      {/*    <Box className={searchbarClasses.divider} />*/}
      {/*    <IconButton*/}
      {/*      className={searchbarClasses.button}*/}
      {/*      onClick={onFilterClick}*/}
      {/*      size="small"*/}
      {/*    >*/}
      {/*      <FilterListIcon className={searchbarClasses.icon} />*/}
      {/*    </IconButton>*/}
      {/*  </>*/}
      {/*) : null}*/}

      {isFocused && hasValue && results.length > 0 && (
        <SearchResults results={results} handleSelect={handleSelect} />
      )}
    </SearchbarStyled>
  );
};
